<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="">
      <div class="py-10">
        <div class="container px-4 mx-auto max-w-[1200px] flex flex-col gap-10">
          <div>

      
            <form
              ref="addCourseRef"
              class="rounded-2xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto bg-white"
              style="box-shadow: 0px 2px 20px 0px #105c8e26"
              @submit.prevent="updateDetails"
            >
              <div class="flex items-start justify-between gap-4">
                
                <div>
                  <h1 class="py-2 text-xl text-center font-bold text-blues">
                    Edit Course
                  </h1>
                </div>


                <div @click="closeEmit"
                    class="bg-blues text-white rounded-lg text-sm font-semibold px-3 py-1 cursor-pointer"
                    >Close</div
                >

              </div>

              <div class="py-10 flex flex-col gap-6">

                <div
                  class="grid grid-cols-1 md:grid-cols-2 gap-5"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="title" class="text-sm"
                      >Section <span class="text-red-400">*</span></label
                    >
                    <input
                      id="title"
                      v-model="courseInfo.section"
                      type="text"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  

                  <div class="flex flex-col gap-3 w-full">
                    <label for="instructor_id" class="text-sm"
                      >Select Instructor </label
                    >
                    <select
                      name="instructor_id"
                      
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="instructor_id"
                    >
                    <option
                      v-for="instructor_list in instructor_lists"
                      :key="instructor_list.id"
                      :value="instructor_list.id"
                    >
                      {{ instructor_list.user.email }}
                    </option>
                    </select>
                  </div>

                </div>

                <div
                  class="grid grid-cols-1 md:grid-cols-2 gap-5"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="title" class="text-sm"
                      >Title <span class="text-red-400">*</span></label
                    >
                    <input
                      id="title"
                      v-model="courseInfo.title"
                      type="text"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="course_code" class="text-sm"
                      >Course Code <span class="text-red-400">*</span></label
                    >
                    <input
                      id="course_code"
                      type="text"
                      v-model="courseInfo.course_code"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>

                  <!-- <div class="flex flex-col gap-3 w-full">
                    <label for="category" class="text-sm"
                      >Category <span class="text-red-400">*</span></label
                    >
                    <select
                      name="category"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="category"
                    >
                      <option
                        v-for="category in categories"
                        :key="category"
                        :value="category.id"
                      >
                        {{ category.title }}
                      </option>
                    </select>
                  </div> -->
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="shortDesc" class="text-sm"
                    >Course objective is to
                    <span class="text-red-400">*</span></label
                  >
                  <textarea
                    id="shortDesc"
                    required
                    v-model="courseInfo.short_description"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="description" class="text-sm"
                    >Description <span class="text-red-400">*</span></label
                  >
                  <QuillEditor
                    style="height: 300px"
                    theme="snow"
                    class="border rounded-2xl"
                    toolbar="full"
                    :content="description"
                    contentType="html"
                  />
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="outcome" class="text-sm">Outcome</label>
                  <textarea
                    id="outcome"
                    v-model="courseInfo.outcome"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>

                <div class="flex flex-col gap-3 w-full">
                  <label for="requirement" class="text-sm">Requirement</label>
                  <textarea
                    id="requirement"
                    v-model="courseInfo.requirements"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>

                <div
                  class="grid grid-cols-1 md:grid-cols-2 gap-5"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="language" class="text-sm"
                      >Language </label
                    >
                    <!-- <input
                      id="language"
                      v-model="courseInfo.language"
                      type="text"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    /> -->

                    <select
                    id="languages"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="lang in languageList"
                      :key="lang.id"
                      :value="lang.id"
                    >
                      {{ lang.title }}
                    </option>
                  </select>
                  </div>

                  <div class="flex flex-col gap-3">
                    <label for="category" class="text-sm flex gap-2"
                      >Course Type 
                      <font-awesome-icon
                        @click="isCourseTypePopup = true"
                        class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                        :icon="['fas', 'plus']"
                        title="Add Category"
                      />
                    </label>
                    <select
                      id="course_type"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    >
                    <option value="" selected disabled>Select Course Type</option>
                      <option
                        v-for="type in courseTypeList"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.title }}
                      </option>
                    </select>
                  </div>

                  <!-- <div class="flex flex-col gap-3 w-full">
                    <label for="level" class="text-sm">Level</label>
                    <select
                      name="level"
                      required
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                      id="level"
                    >
                      <option
                        v-for="level in [
                          'beginner',
                          'intermediate',
                          'advanced',
                        ]"
                        :key="level"
                        :value="level"
                      >
                        {{ level }}
                      </option>
                    </select>
                  </div> -->
                </div>

                <div
                  class="grid grid-cols-1 md:grid-cols-2 gap-5"
                >
                  <div class="flex flex-col gap-3 w-full">
                    <label for="thumbnail" class="text-sm"
                      >Thumbnail <span class="text-red-400">*</span></label
                    >
                    <img
                      :src="courseInfo.thumbnail"
                      class="w-[150px] h-[100px] rounded-lg"
                      alt=""
                    />
                    <input
                      id="thumbnail"
                      type="file"
                      class="bg-[#F9FAFC] object-cover rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="videoUrl" class="text-sm">Video URL</label>
                    <input
                      id="videoUrl"
                      v-model="courseInfo.video_url"
                      type="text"
                      class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                    />
                  </div>
                </div>

                <div class="flex items-center gap-4">
                  <div class="flex items-center gap-2">
                    <label for="checkbox">Published</label>
                    <input
                      type="checkbox"
                      id="Published"
                      v-model="courseInfo.is_published"
                    />
                  </div>
                </div>
                <div class="flex gap-3 flex-wrap">
                  <button
                    type="submit"
                    class="text-greens border border-greens rounded-lg text-lg font-semibold px-6 py-1.5"
                  >
                    Save
                  </button>
                 
                </div>
              </div>
            </form> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    QuillEditor,
    FlashMessage,
  },

  data() {
    return {
      courseInfo: "",
      categories: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      instructor_lists:[],
      languageList: [],
      courseTypeList: []
    };
  },

  props: ["course_id", "batchYear", "departmentName", "programName", "semesterName"],

  computed: mapGetters(["userInfo"]),

  async created() {
    this.description = this.courseInfo.description;

    axios
      .get(`${process.env.VUE_APP_API}/courses/?id=${this.course_id}&Key=${this.userInfo.token_key}`)
      .then((response) => {
        this.courseInfo = response.data.data[0];
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });

    this.getInstructorListByFilter();
      this.getLanguages();
      this.getCourseTypeList();
  },

  methods: {

    getCourseTypeList(){
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    getLanguages(){
      axios
        .get(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.languageList = res.data.data;
        });
    },

    getInstructorListByFilter(){
      axios
      .get(
        `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}&department__name=${this.departmentName}`
      )
      .then((res) => {
        console.log(res);
        this.instructor_lists = res.data.products;
      });
    },

    closeEmit() {
      this.$emit("close-EmitEdit");
    },

    async updateDetails(el) {
      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      let instructor_details;
      await axios
        .get(`${process.env.VUE_APP_API}/coursesdata/${this.courseInfo.id}/?Key=${this.userInfo.token_key}`)
        .then((Response) => {
          instructor_details = Response.data;
        });

      let updatedCourseInfo = {
        instructor: instructor_details.instructor_id,
        uid: this.courseInfo.uid,
        title: el.target.elements.title.value,
        slug: this.courseInfo.slug,
        short_description: el.target.elements.shortDesc.value,
        description: this.description,
        outcome: el.target.elements.outcome.value,
        requirements: el.target.elements.requirement.value,
        languages: el.target.elements.languages.value,
        price: 0,
        course_free: true,
        // level: el.target.elements.level.value,
        video_url: el.target.elements.videoUrl.value,
        is_published: el.target.elements.Published.checked,
        created_at: this.courseInfo.created_at,
        updated_at: this.courseInfo.updated_at,
        // category: parseInt(el.target.elements.category.value),
        organization_id: this.userInfo.organizes_id,
        thumbnail: el.target.elements.thumbnail.files[0],
      };

      await axios
        .put(
          `${process.env.VUE_APP_API}/courseupdate/${this.courseInfo.id}/?Key=${this.userInfo.token_key}`,
          updatedCourseInfo,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.res = response;
          if (this.res.data.message) {
            this.messages = {
              text: "Course Updated successfully",
              type: "success",
            };
            // console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            // console.log("not successful");
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        // this.$router.push({
        //   name: "InstructorCourses",
        // });
      }, 2500);
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
